import AllLanguagesFlag from '@/shared/LanguageFlag/AllLanguagesFlag';
import FrenchFlag from '@/shared/LanguageFlag/FrenchFlag';
import SpanishFlag from '@/shared/LanguageFlag/SpanishFlag';

const Language = {
  labels: {
    es: <SpanishFlag />,
    fr: <FrenchFlag />,
    all: <AllLanguagesFlag />,
  },
};

export default Language;
